export enum ClassFormat {
  loginInput = "rounded xl:h-[50px] h-[40px]",
  inputLabel = "xl:text-[16px] text-[14px] text-[#909090]",
  inputIcon = "pr-1 xl:text-[17px] text-[14px] text-[#909090]",
  packageLookUpLabel = "flex gap-x-1 justify-center items-center",
  packageLookUpInfoLabel = "font-[600] xl:text-[13px] text-[12px] text-[#909090]",
  packageLookUpInfoValue = "font-[600] xl:text-[16px] text-[14px]",
  documentLabel = "font-[600] xl:text-[13px] text-[12px] truncate-multiline break-words w-1/2",
  closeIconForImagePreview = "absolute -top-2 -right-2 text-red-500 text-xl cursor-pointer drop-shadow-md hover:text-red-600 hover:scale-110 transition-transform duration-200",
  topupInfoLabel = "text-[#9CA3AF] xl:text-[16px] text-[13px] break-words text-center",
  topupInfoValue = "text-[#1677ff] xl:text-[18px] text-[15px] font-[600] break-words text-center"
}
